module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "export"
  }, [_c('div', {
    staticClass: "export-download print",
    on: {
      "click": function($event) {
        return _vm.printChart()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('graphs/export/Print chart')) + " ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "export-download png-download",
    on: {
      "click": function($event) {
        return _vm.downloadPNG()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('graphs/export/Download')) + " PNG " + _vm._s(_vm.$l('graphs/export/image')) + "  ")]), _vm._v(" "), _c('div', {
    staticClass: "export-download jpeg-download",
    on: {
      "click": function($event) {
        return _vm.downloadJPEG()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('graphs/export/Download')) + " JPEG " + _vm._s(_vm.$l('graphs/export/image')) + "  ")]), _vm._v(" "), _c('div', {
    staticClass: "export-download pdf-download",
    on: {
      "click": function($event) {
        return _vm.downloadPDF()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('graphs/export/Download')) + " PDF  ")]), _vm._v(" "), _c('div', {
    staticClass: "export-download svg-download",
    on: {
      "click": function($event) {
        return _vm.downloadSVG()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('graphs/export/Download')) + " SVG " + _vm._s(_vm.$l('graphs/export/image')) + "  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b70f5576","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/graphs/ExportGraph.vue
// module id = 477
// module chunks = 1